
import { useNavigate } from "react-router-dom";
import { Product } from "@/lib/types";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Package, BarChart2, AlertTriangle, ArrowRight } from "lucide-react";

interface StatsSummaryProps {
  products: Product[];
  lowStockProducts: Product[];
}

const StatsSummary = ({ products, lowStockProducts }: StatsSummaryProps) => {
  const navigate = useNavigate();

  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <Card className="glass-card hover:shadow-md transition-shadow">
        <CardContent className="flex items-center justify-between p-6">
          <div className="flex items-center">
            <div className="bg-blue-100 dark:bg-blue-900/30 p-3 rounded-full mr-4">
              <Package className="h-6 w-6 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Total Products
              </p>
              <h3 className="text-2xl font-bold">{products.length}</h3>
            </div>
          </div>
          <Button 
            variant="ghost" 
            onClick={() => navigate("/products")}
            className="rounded-full h-9 w-9 p-0"
          >
            <ArrowRight className="h-5 w-5" />
          </Button>
        </CardContent>
      </Card>
      
      <Card className="glass-card hover:shadow-md transition-shadow">
        <CardContent className="flex items-center justify-between p-6">
          <div className="flex items-center">
            <div className="bg-purple-100 dark:bg-purple-900/30 p-3 rounded-full mr-4">
              <BarChart2 className="h-6 w-6 text-purple-600 dark:text-purple-400" />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Analytics
              </p>
              <h3 className="text-2xl font-bold">View</h3>
            </div>
          </div>
          <Button 
            variant="ghost" 
            onClick={() => navigate("/analytics")}
            className="rounded-full h-9 w-9 p-0"
          >
            <ArrowRight className="h-5 w-5" />
          </Button>
        </CardContent>
      </Card>
      
      <Card className="glass-card hover:shadow-md transition-shadow">
        <CardContent className="flex items-center justify-between p-6">
          <div className="flex items-center">
            <div className="bg-amber-100 dark:bg-amber-900/30 p-3 rounded-full mr-4">
              <AlertTriangle className="h-6 w-6 text-amber-600 dark:text-amber-400" />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Low Stock Items
              </p>
              <h3 className="text-2xl font-bold">{lowStockProducts.length}</h3>
            </div>
          </div>
          <Button 
            variant="ghost" 
            onClick={() => navigate("/products")}
            className="rounded-full h-9 w-9 p-0"
          >
            <ArrowRight className="h-5 w-5" />
          </Button>
        </CardContent>
      </Card>
    </section>
  );
};

export default StatsSummary;
